import { takeLatest, call, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api';

export function* updateProfile({ payload }) {
  try {
    const { oldPassword, password, confirmPassword } = payload.data;

    const profile = {
      oldPassword,
      password,
      confirmPassword,
    };

    yield call(api.put, 'users', profile);

    toast.success('Perfil atualizado com sucesso!');
  } catch (err) {
    toast.error('Erro ao atualizar perfil, confira seus dados.');
  }
}

export default all([takeLatest('@user/UPDATE_PROFILE_REQUEST', updateProfile)]);